export interface IStorageBucket {
  _links: {
    self: {
      href: string
    }
    sign_post: {
      href: string
    }
    remove: {
      href: string
      method: string
    }
    subscriptions: {
      href: string
    }
  }
  alias: string
  name: string
  store: string
}

export interface IStorageFolder {
  _links: {
    sign_post: {
      href: string
    }
    remove: {
      href: string
      method: string
    }
  }
  name: string
  is_dir: boolean
}

export interface IStorageFile {
  _links: {
    remove: {
      href: string
      method: string
    }
    get?: {
      href: string
    }
    sign_get?: {
      href: string
    }
    sign_put?: {
      href: string
    }
  }
  name: string
  size: number // in bytes
  last_modified: string
  is_dir: boolean
}

export interface IStorageSubscription {
  id: string
  title?: string
  description?: string
  channel: { name: string }
  filters: IFilter[]
  _links: {
    create: {
      href: string
      method: string
    }
  }
}

export interface IFilter {
  prefix: string
  suffix: string
  onFileChange: boolean
  onFileDelete: boolean
  events?: string[]
}

export enum EMode {
  add = 'add',
  edit = 'edit',
}
